// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-about-js": () => import("../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-examples-js": () => import("../src/pages/examples.js" /* webpackChunkName: "component---src-pages-examples-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lyric-video-maker-js": () => import("../src/pages/lyric-video-maker.js" /* webpackChunkName: "component---src-pages-lyric-video-maker-js" */),
  "component---src-pages-music-visualizer-js": () => import("../src/pages/music-visualizer.js" /* webpackChunkName: "component---src-pages-music-visualizer-js" */),
  "component---src-pages-pricing-js": () => import("../src/pages/pricing.js" /* webpackChunkName: "component---src-pages-pricing-js" */)
}

